<template>
  <div class="lesson-transcription">
    <template v-if="color">
      <div class="text-primary d-flex mb-3">
        <i class="far fa-file-pdf mr-2 mt-1"></i>
        <span class="text-uppercase"> TRANSCRIÇÕES GW {{ date }} COLOR </span>
      </div>
      <button
        class="btn btn-primary btn-block strong py-2 mb-5"
        @click="$emit('read', color)"
      >
        LER TRANSCRIÇÃO
      </button>
    </template>

    <template v-if="black">
      <div class="text-secondary d-flex mb-3">
        <i class="far fa-file-pdf mr-2 mt-1"></i>
        <span class="text-uppercase"> TRANSCRIÇÕES GW {{ date }} PB </span>
      </div>
      <button
        class="btn btn-outline-secondary btn-block strong py-2"
        @click="$emit('read', black)"
      >
        LER TRANSCRIÇÃO
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      default: ""
    },
    color: {
      type: Object,
      default: null
    },
    black: {
      type: Object,
      default: null
    }
  }
};
</script>
